import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ShieldAlert } from "lucide-react";
import { useEmpresa } from "@/context/EmpresaContext";

// Alerta no topo quando um certificado A1 da empresa vence em até 30 dias (ou já venceu)
export default function CertificadoAviso() {
  const { empresaAtualId } = useEmpresa();
  const [alerta, setAlerta] = useState([]);
  useEffect(() => {
    api.get("/gestao/certificados").then((r) => setAlerta(r.data.alerta || [])).catch(() => setAlerta([]));
  }, [empresaAtualId]);
  if (!alerta.length) return null;
  const c = alerta[0];
  return (
    <Link to="/gestao" data-testid="certificado-aviso"
          className="flex items-center gap-1.5 rounded-md border border-rose-300 bg-rose-50 px-2.5 py-1.5 text-xs font-semibold text-rose-700 hover:bg-rose-100">
      <ShieldAlert className="w-4 h-4" />
      {c.dias_restantes < 0 ? `Certificado vencido (${c.uso})` : `Certificado vence em ${c.dias_restantes} dias`}
    </Link>
  );
}
